<script>
    import { Bar, mixins } from 'vue-chartjs';
    import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
    export default {
        mounted() {
            this.draw()
        },
        props: ['chartData','groups', 'render_info', 'height','width','additional_filters'],
        extends: Bar,
        mixins: [mixins.reactiveProp],
        watch: {
            chartData: function () {
                this.draw()
            },
        },
        methods: {
            commarize(number, precision) { // precision is how many places after the decimal point
                let min = 1e3;
                // Alter numbers larger than 1k
                if (number >= min) {
                    var units = ["k", "M", "B", "T", "Q"];

                    var order = Math.floor(Math.log(number) / Math.log(1000));

                    var unitname = units[(order - 1)];
                    var num = Math.floor(number / ((1000 ** order)/(10**precision)))/(10**precision);

                    // output number remainder + unitname
                    return num.toLocaleString() + unitname
                }

                // return formatted original number
                return number.toLocaleString()
            },
            effortize(number,precision) {
              let hour = 60
              let workday = hour * 8
              let workweek = hour * 40
              let workmonth = hour * 160
              let workyear = workmonth * 12
              let unitname = 'minute'
              let num = number
              if (number>=workyear) {
                num = Math.floor(number / ((workyear)/(10**precision)))/(10**precision);
                unitname = 'work year'
              } else if (number>=workmonth) {
                num = Math.floor(number / ((workweek)/(10**precision)))/(10**precision);
                unitname = 'work month'
              } else if (number>=workweek) {
                num = Math.floor(number / ((workweek)/(10**precision)))/(10**precision);
                unitname = 'work week'
              } else if (number>=workday) {
                num = Math.floor(number / ((workday)/(10**precision)))/(10**precision);
                unitname = 'work day'
              } else if (number>=hour) {
                num = Math.floor(number / ((hour)/(10**precision)))/(10**precision);
                unitname = 'work hour'
              }
              return num + ' ' + unitname + (num===1 ? '' : 's')
            },
            setThreshold() {
                if ((!this.chartData) || (!this.chartData.meta) || (!this.chartData.meta.barSizes)) {
                    this.unstacked_label_threshold = Number.MAX_VALUE
                } else {
                    let barSizes = this.chartData.meta.barSizes
                    let first_value = barSizes[0]
                    let last_value = barSizes[barSizes.length - 1] // "OTHER" could be the max
                    let max = this.max_value = first_value
                    if (first_value < last_value) {
                        max = last_value
                    }
                    this.unstacked_label_threshold = max / 20;
                }
            },
            set_x_axis_type() {
                this.x_axis_type = 'string'
                if (!this.chartData) {
                    return
                } else {
                    this.chartData.labels.forEach((label)=> {
                        let label_as_number = parseFloat(label)
                        if (typeof label_as_number !== 'number') {
                            return
                        }
                    });
                    this.x_axis_type = 'number'
                }
            },
            draw() {
                if ((this.chartData) && this.chartData.datasets && (this.chartData.datasets.length > 1)) {
                    this.options = this.options_stacked
                }
                else {
                    this.options = this.options_simple
                }
                this.setThreshold()
                if (this.max_value > 1000) {
                  this.y_axis_precision = 1
                } else {
                  this.y_axis_precision = 0
                }
                if (!this.render_info || this.render_info.display_extra) {
                    this.options.legend.display = true
                    this.options.scales.xAxes[0].ticks.display = true
                    this.options.scales.yAxes[0].ticks.display = true
                    if ((!this.chartData) || (!this.chartData.meta) || (this.chartData.meta.xLabel === undefined)) {
                        this.options.scales.xAxes[0].scaleLabel.display = false
                        this.options.scales.yAxes[0].scaleLabel.display = false
                        this.options.scales.xAxes[0].scaleLabel.labelString = 'x'
                        this.options.scales.yAxes[0].scaleLabel.labelString = 'y'
                    } else {
                        this.options.scales.xAxes[0].scaleLabel.display = true
                        this.options.scales.yAxes[0].scaleLabel.display = true
                        this.options.scales.xAxes[0].scaleLabel.labelString = this.chartData.meta.xLabel
                        this.options.scales.yAxes[0].scaleLabel.labelString = this.chartData.meta.yLabel
                    }
                } else {
                    this.options.legend.display = false
                    this.options.scales.xAxes[0].ticks.display = false
                    this.options.scales.yAxes[0].ticks.display = false
                    this.options.scales.xAxes[0].scaleLabel.display = false
                    this.options.scales.yAxes[0].scaleLabel.display = false
                }
                this.renderChart(this.chartData,this.options)
                this.$data._chart.canvas.parentNode.style.height = this.height + 'px'
                this.$data._chart.canvas.parentNode.height = this.height + 'px'
              console.log('(In ChartBar) draw -- additional_filters:')
              console.log(this.additional_filters)
            }
        },
        data() {
            return {
                max_value: 0,
                y_axis_precision: 0,
                x_axis_type: 'string',
                rendered_labels: {
                    title: {
                        font: {
                            weight: 'normal'
                        }
                    },
                },
                hidden_labels: {
                    title: null
                },
                unstacked_label_threshold: null,
                options: null,
                options_simple: {
                    // responsive: false,
                    maintainAspectRatio: false,
                    onClick: (e) => {
                        const element = this.$data._chart.getElementAtEvent(e);
                        if (element.length) {
                            //A 'bar' was clicked, do the existing flow..
                            const label = this.$data._chart.data.labels[element[0]._index];
                            this.$emit('stackChartClicked', {index: element[0]._index, color: this.$data._chart.getElementAtEvent(e)[0]._model.datasetLabel, label});
                        } else {
                            //A 'bar' was not clicked, get the label for the covered area..
                            const mousePoint = window.Chart.helpers.getRelativePosition(e, this.$data._chart);
                            const clickX = this.$data._chart.scales['x-axis-0'].getValueForPixel(mousePoint.x);
                            const label = this.$data._chart.data.labels[clickX];
                            //Do something with label..
                            this.$emit('barLabelClicked',{label: label})
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                autoSkip: false,
                                userCallback: (value, index, values) => {
                                    if (
                                        this.chartData && this.chartData.meta &&
                                        this.chartData.meta.yLabel && this.chartData.meta.yLabel.endsWith(' effort')
                                    ) {
                                      return this.effortize(value, this.y_axis_precision)
                                    } else {
                                      return this.commarize(value,this.y_axis_precision)
                                    }
                                },
                                display: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: '',
                                fontStyle: 'italic',
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                autoSkip: false,
                                userCallback: (value, index, values) => {
                                    if (this.x_axis_type==='number') {
                                        return this.commarize(value, 0)
                                    } else {
                                        return value
                                    }
                                },
                                display: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: '',
                                fontStyle: 'italic',
                            }
                        }]
                    },
                    legend: {
                        display: true
                    },
                    plugins: {
                        datalabels: {
                            align: 'end',
                            anchor: 'end',
                            color: 'black',
                            labels: {
                                title: true,
                            },
                            display: (context) => {
                                if (this.chartData && this.chartData.meta) {
                                    let value = this.chartData.meta.barSizes[context.dataIndex]
                                    return (value <= this.unstacked_label_threshold);
                                } else {
                                    return false;
                                }
                            },
                            formatter: (value, context) => {

                                return this.commarize(value,1);
                            }
                        }
                    }
                },
                options_stacked: {
                    // responsive: false,
                    maintainAspectRatio: false,
                    onClick: (e) => {
                        const element = this.$data._chart.getElementAtEvent(e);
                        if (element.length) {
                            //A 'bar' was clicked, do the existing flow..
                            const label = this.$data._chart.data.labels[element[0]._index];
                            this.$emit('stackChartClicked', {index: element[0]._index, color: this.$data._chart.getElementAtEvent(e)[0]._model.datasetLabel, label});
                        } else {
                            //A 'bar' was not clicked, get the label for the covered area..
                            const mousePoint = window.Chart.helpers.getRelativePosition(e, this.$data._chart);
                            const clickX = this.$data._chart.scales['x-axis-0'].getValueForPixel(mousePoint.x);
                            const label = this.$data._chart.data.labels[clickX];
                            //Do something with label..
                            this.$emit('barLabelClicked',{label: label})
                        }
                    },
                    scales: {
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                autoSkip: false,
                                userCallback: (value, index, values) => {
                                    return this.commarize(value,this.y_axis_precision)
                                },
                                display: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'probability'
                            }
                        }],
                        xAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                autoSkip: false,
                                userCallback: (value, index, values) => {
                                    if (this.x_axis_type==='number') {
                                        return this.commarize(value, 0)
                                    } else {
                                        return value
                                    }
                                },
                                display: true
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'probability'
                            }
                        }],
                    },
                    legend: {
                        display: true
                    },
                    plugins: {
                        datalabels: {
                            align: 'end',
                            anchor: 'end',
                            color: 'black',
                            labels: {
                                title: true,
                            },
                            display: (context) => {
                                if (!this.chartData) return true;
                                let value = this.chartData.meta.barSizes[context.dataIndex]
                                return (context.datasetIndex === this.chartData.datasets.length - 1 ) && (value <= this.unstacked_label_threshold);
                            },
                            formatter: (value, context) => {
                                if (!this.chartData) return true;
                                let new_value = this.chartData.meta.barSizes[context.dataIndex]
                                return this.commarize(new_value,1);
                            }
                        }
                    }
                }
            }
        },
    }
</script>